import { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';

const FULLSCREEN_PARAM = 'fullscreen';

/**
 * Hook for managing panel fullscreen state via URL query parameter.
 * The URL is the single source of truth - no separate state is maintained.
 */
export function usePanelFullscreen() {
  const [searchParams, setSearchParams] = useSearchParams();

  const isFullscreen = searchParams.get(FULLSCREEN_PARAM) === 'true';

  const enterFullscreen = useCallback(() => {
    setSearchParams(
      (prev) => {
        prev.set(FULLSCREEN_PARAM, 'true');
        return prev;
      },
      { replace: true }
    );
  }, [setSearchParams]);

  const exitFullscreen = useCallback(() => {
    setSearchParams(
      (prev) => {
        prev.delete(FULLSCREEN_PARAM);
        return prev;
      },
      { replace: true }
    );
  }, [setSearchParams]);

  const toggleFullscreen = useCallback(() => {
    if (isFullscreen) {
      exitFullscreen();
    } else {
      enterFullscreen();
    }
  }, [isFullscreen, enterFullscreen, exitFullscreen]);

  return {
    isFullscreen,
    toggleFullscreen,
    enterFullscreen,
    exitFullscreen,
  };
}
